import { render, staticRenderFns } from "./SponsoredRecommendationVideoSearch.vue?vue&type=template&id=e420eaea&scoped=true"
import script from "./SponsoredRecommendationVideoSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationVideoSearch.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationVideoSearch.vue?vue&type=style&index=0&id=e420eaea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e420eaea",
  null
  
)

export default component.exports